import axios from 'axios';

export class FontAwesomeController {
    /**
     * Get icons from the Font Awesome kit via the backend proxy.
     *
     * @returns {Array|Error}
     */
    static async getIcons() {
        try {
            const response = await axios.get('font-awesome/icons');
            return response?.data.sort((a, b) => a.class > b.class ? 1 : -1) ?? [];
        } catch (error) {
            console.error('Error to get icons', error);
            throw error;
        }
    }
}
